import axios from 'axios';
import { baseUrl_SPB } from '../../BaseUrl';

// Fetch all expenses (reimbursements)
export const fetchExpenses = async (token,companyId) => {
	return axios.get(`${baseUrl_SPB}/api/v1/reimburse/retrieveexpenses/approved?companyId=${companyId}`, {
		headers: {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer ' + token
		}
	});
};
